<template>
    <div>LOG BOOK CASH TICKET</div>
</template>